module.exports = __webpack_public_path__ + "static/media/instagramLogoSquare.e5b9b105.png";